import React from 'react'
import { useTranslation } from 'react-i18next'
import { Control, FieldErrors } from 'react-hook-form'
import { ControlledTextField } from '../../../form/ControlledTextField'
import { validators } from '../../../../validation/validators'
import { InternalFormValues } from '../form-values'

type Props = {
  control: Control<InternalFormValues>
  errors: FieldErrors<InternalFormValues>
}

export function InefficientDeviceForm({
  control,
  errors,
}: Props): React.ReactElement {
  const { t } = useTranslation()

  return (
    <ControlledTextField
      control={control}
      name="parameters.inefficientDevice.efficiency"
      rules={{
        ...validators.required,
        ...validators.efficiency,
      }}
      error={errors.parameters?.inefficientDevice?.efficiency}
      label={t('createProvider.forms.inefficient.efficiency')}
      defaultValue="1"
    />
  )
}
